import { getCookie, setCookieWithExpiry } from './helpers';


const getSfwParameter = () => {
  const params = new URLSearchParams(window.location.search);
  const sfwParam = params.get('SFW_TEST');

  return sfwParam?.toLowerCase() === 'true';
};

const setSfwParameterCookie = () => {
  const sfwParam = getSfwParameter();
  setCookieWithExpiry('SFW_TEST', sfwParam, 7);

  return sfwParam;
};

export const overrideStatusResponse = async(data, temptedData) => {
  // Allow QA to test
  const sfwTestCookie =
    setSfwParameterCookie() || getCookie('SFW_TEST') === 'true';
  const { data: dataTempted, error: errorTempted } = temptedData;

  if (!errorTempted) {
    if (data && data.data && data.data.user && data.data.user.account) {
      if (
        dataTempted &&
        dataTempted.data &&
        dataTempted.data.user &&
        dataTempted.data.user.account
      ) {
        if (dataTempted.data.user.account.anchorSubscriptions) {
          data.data.user.account.anchorSubscriptions =
            dataTempted.data.user.account.anchorSubscriptions;
        }
        if (dataTempted.data.user.account.nickname) {
          data.data.user.account.nickname =
            dataTempted.data.user.account.nickname;
        }
        if (dataTempted.data.user.account.affiliateCode) {
          data.data.user.account.affiliateCode =
            dataTempted.data.user.account.affiliateCode;
        }
        if (dataTempted.data.user.account.id) {
          data.data.user.account.temptedId = dataTempted.data.user.account.id;
        }
        data.data.user.account.blockFanzoneAccess =
          dataTempted?.data?.user?.account?.role === 'ROLE_STAR' &&
          data?.data?.user?.account?.role === 'USER';
        data.data.user.account.unverifiedEmail =
          dataTempted.data.user.account.unverifiedEmail;

        data.data.user.account.createdDuringCombinedPromoEvent =
          dataTempted?.data?.user?.account?.createdDuringCombinedPromoEvent;
        data.data.user.account.nicknameUpdateCounter =
          dataTempted?.data?.user?.account?.nicknameUpdateCounter;
      }
    }

    const isAuthenticated = data?.data?.authenticated === true;

    const sfwProperty = isAuthenticated ? 'sfw' : 'sfwGuest';

    if (typeof dataTempted?.data?.[sfwProperty] === 'boolean') {
      data.data.sfw = !!sfwTestCookie || dataTempted.data[sfwProperty];
    }

    if (dataTempted?.data?.features) {
      data.data.temptedFeatures = dataTempted.data.features;
    }
  } else {
    console.error(errorTempted);
  }
};
